import languages from '@/data/languages.json'
import { useResourceStore } from '@/pinia'
import { GetLanguage, SetLanguage } from '@/utils-ts'
import { createI18n } from 'vue-i18n'

export { useI18n as UseI18n } from 'vue-i18n'

export const i18n = createI18n({
  legacy: false,
  locale: 'tr',
  fallbackLocale: 'tr',
  globalInjection: true,
  missingWarn: false,
  fallbackWarn: false,
  messages: {},
  warnHtmlMessage: false,
})

export const GetLanguageData = async (c: string | null = null) => {
  const code = c || GetLanguage().code
  const language = languages.find(lang => lang.code === code)
  if (language) {
    SetLanguage(code)
  }
  const response = language ? await useResourceStore().GetResourceList(language.id) : {}

  if (language) {
    i18n.global.locale.value = language.code
    i18n.global.setLocaleMessage(language.code, response)
  }
}

export const Format = i18n.global.t
